<template>
  <!-- 已分配业务员 -->
  <Modal v-model="visible" :mask-closable="false" :footer-hide="true" title="已分配业务员" width="1000" class="my-modal">
    <div class="search-box ban3">
      <div class="input-item">
        <span class="label">机构名称</span>
        <Input type="text" v-model="searchParams.organizationName" placeholder="请输入" clearable />
      </div>
      <div class="input-item">
        <span class="label">业务员名称</span>
        <Input type="text" v-model="searchParams.salesmanName" placeholder="请输入" clearable />
      </div>
      <div class="input-item">
        <span class="label">状态</span>
        <Select v-model="searchParams.status" clearable>
          <Option value="null">全部</Option>
          <Option :value="0">禁用</Option>
          <Option :value="1">启用</Option>
        </Select>
      </div>
      <div class="btn-item">
        <Button type="primary" @click="searchAjax()">查询</Button>
      </div>
    </div>
    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="status">
          <div>
            <i-switch v-model="row.status" :disabled="row.workingState == 0 || row.isSus == 1" :true-value="1" :false-value="0" :before-change="() => changeStatus(row)" size="large">
              <span slot="open">启用</span>
              <span slot="close">禁用</span>
            </i-switch>
          </div>
        </template>
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" :class="{'disabled':row.status == 0}"  @click="$refs.modifyNumModal.open(row)">编辑</span>
          <span class="table-btn" @click="$refs.updateRecordModal.open(row)">份额更新记录</span>
          <span class="table-btn" @click="$refs.orderListModal.open(row)">赠送记录</span>
        </template>
      </Table>
      <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" v-if="tableData.length" />
    </div>
    <!-- 修改次数 -->
    <modify-num-modal @reload="$emit('reload');getList()" ref="modifyNumModal" :remainGiftNum="remainGiftNum"></modify-num-modal>
    <!-- 更新记录 -->
    <update-record-modal ref="updateRecordModal"></update-record-modal>
    <!-- 赠险订单列表 -->
    <order-list-modal ref="orderListModal"></order-list-modal>
  </Modal>
</template>
<script>
import OrderListModal from './orderListModal.vue';
import ModifyNumModal from './modifyNumModal';
import UpdateRecordModal from './updateRecordModal.vue';
import { pageTool, common } from '@/api/mixins';
export default {
  props: {
    remainGiftNum: null,// 商户可用份额
  },
  mixins: [pageTool, common],
  components: {
    ModifyNumModal,
    UpdateRecordModal,
    OrderListModal
  },
  data: () => ({
    listLoading: false,
    visible: false,
    columns: [
      {
        title: '所属机构',
        key: 'organizationName',
        align: 'center'
      },
      {
        title: '业务员名称',
        key: 'salesmanName',
        width: 100,
        align: 'center'
      },
      {
        title: '已投保份额',
        key: 'payGiftNum',
        align: 'center',
        width: 100
      },
      {
        title: '已赠送未投保份额',
        key: 'unPayGiftNum',
        align: 'center',
        width: 100
      },
      {
        title: '剩余可用份额',
        key: 'remainGiftNum',
        align: 'center',
        width: 100
      },
      {
        title: '创建时间',
        key: 'createTime',
        align: 'center',
        width: 120,
        render(h, params) {
          if (params.row.createTime) {
            const value = params.row.createTime.split(' ')[0];
            return <div>{value}</div>;
          } else {
            return <div></div>;
          }
        }
      },
      {
        title: '状态',
        width: 100,
        slot: 'status',
        key: 'status',
        align: 'center'
      },
      {
        title: '操作',
        slot: 'action',
        align: 'center',
        width: 240
      }
    ],
    searchParams: {},
    giftId: ''
  }),
  created() {},
  methods: {
    open(item) {
      this.giftId = item.id;
      this.pageNo = 1;
      this.searchParams = {
        merchantJoinId: this.giftId,
        organizationName: '',
        salesmanName: '',
        status: 'null'
      };
      this.visible = true;
      this.initListAjax('/buz/giveawayProduct/queryAllocatedSalesmanList');
    },
    // 转化参数
    setListParams(params) {
      if(params.status == 'null') {
        delete params.status;
      }
    },
    // 修改状态
    changeStatus(row) {
      return new Promise((resolve, reject) => {
        this.$Modal.confirm({
          title: '提示',
          content: '<p>请确认是否更改业务员分配状态</p>',
          onOk: () => {
            this.$http({
              url: '/buz/giveawayProduct/updateSalesmanGiveawayJoin',
              type: 'POST',
              data: {
                id: row.id,
                status: row.status == 1 ? 0 : 1
              }
            }).then(res => {
              resolve();
              this.getList();
              this.$notice.success('修改成功');
              this.$emit('reload');
            });
          },
          onCancel: () => {
            reject();
          }
        });
      });
    }
  }
};
</script>
<style lang='scss' scoped>
</style>